import { api } from './api';

export type PlanId = 'starter' | 'professional' | 'business' | 'flat' | 'einzelbericht';
export type Billing = 'monthly' | 'annual';

export type TariffApiEntry = {
  code: Exclude<PlanId, 'einzelbericht'>;
  monthlyPrice: number;
  annualMonthlyPrice: number;
  monthlyReportLimit?: number;
  unlimitedReports?: boolean;
  rolloverMonths: number;
  maxSeats: number;
  canUseEsf: boolean;
  canUseTemplates: boolean;
  canExportPdf: boolean;
  canExportDocx: boolean;
  canUseTeam: boolean;
};

export type TariffsResponse = {
  trialDaysAnnual: number;
  teamOption: { priceMonthly: number; totalSeats: number };
  tariffs: TariffApiEntry[];
};

export async function getTariffs(): Promise<TariffsResponse> {
  return api.get<TariffsResponse>('/api/billing/tariffs');
}

export async function createCheckoutSession(plan: PlanId, billing: Billing, teamOption?: boolean): Promise<void> {
  const { url } = await api.post<{ url: string }>('/api/billing/create-checkout-session', { plan, billing, teamOption });
  window.location.href = url;
}

export async function createPortalSession(): Promise<void> {
  const { url } = await api.post<{ url: string }>('/api/billing/create-portal-session');
  window.location.href = url;
}
